import styled from 'styled-components/macro';

export const LockViewContainer = styled.div`
  width: 100%;
  height: 100vh;
  z-index: 999;
  position: fixed;
  background-color: ${({ theme }) => theme.white};
  justify-content: center;
  align-items: center;
  display: none;

  @media (max-width: ${({ theme }) =>
      `${theme.breakpoints.lg}px`}) and (orientation: landscape) {
    display: flex;
  }
`;

export const LockBlock = styled.div`
  width: 500px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 70%;
    transform: rotate(90deg);
  }

  h4 {
    text-align: center;
    position: relative;
    bottom: 40px;
  }
`;
